import { c as _c } from "react-compiler-runtime";
import { useCallback, useRef } from 'react';
import styled from 'styled-components';
import { Popover } from 'foundations-components/transitional/components/Popover';
import useCollaborationSidebarState from '../../hooks/useCollaborationSidebarState';
import EmbeddedCommentIframe from './components/EmbeddedCommentIframe';
import { DELETE_COMMENT_POPOVER_ID, MINI_COMMENTER_ID } from '../../constants/sidebar';
import useEmbeddedCommentsMessaging from './hooks/useEmbeddedCommentsMessaging';
import useEmbeddedComments from './hooks/useEmbeddedComments';
import { useEmbeddedCommentPopover } from './hooks/useEmbeddedCommentPopover';
import { useUserInfo } from 'collaboration-sidebar-common/userInfo/userInfoQueries';
import { jsx as _jsx } from "react/jsx-runtime";
const PopoverContentOverlay = styled.div.withConfig({
  displayName: "EmbeddedCommentPopover__PopoverContentOverlay"
})([".hs-private.hs-private.hs-private &{pointer-events:none;position:fixed;top:", "px;left:", "px;width:", "px;height:", "px;}"], ({
  top
}) => top, ({
  left
}) => left, ({
  width
}) => width, ({
  height
}) => height);
export default function EmbeddedCommentPopover(t0) {
  "use memo";

  const $ = _c(44);
  const {
    iframeContainerID
  } = t0;
  const {
    isEmbeddedPopoverOpen,
    embeddedPopoverPlacement,
    collaborationSidebarState,
    embeddedModuleID,
    embeddedMetaDescription,
    isEmbeddedOpenFromCommentMode,
    onUpdateCollaborationSidebarState
  } = useCollaborationSidebarState();
  const closePopoverOnOutsideClickRef = useRef(true);
  const embeddedPopoverRef = useRef(null);
  const embeddedPopoverContentRef = useRef(null);
  const popoverContentWrapperRef = useRef(null);
  const {
    userInfo
  } = useUserInfo();
  let t1;
  if ($[0] !== onUpdateCollaborationSidebarState) {
    t1 = () => {
      onUpdateCollaborationSidebarState({
        isEmbeddedPopoverOpen: false,
        commentableAreaClickCoordinates: undefined
      });
    };
    $[0] = onUpdateCollaborationSidebarState;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const closeEmbeddedCommentPopover = t1;
  let t2;
  if ($[2] !== closeEmbeddedCommentPopover) {
    t2 = evt => {
      if (closePopoverOnOutsideClickRef.current && !document.querySelector(`[data-element-id="${DELETE_COMMENT_POPOVER_ID}"]`)) {
        if (!evt.target.value) {
          closeEmbeddedCommentPopover();
        }
      }
    };
    $[2] = closeEmbeddedCommentPopover;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleEmbeddedCommentOpenChange = t2;
  const t3 = embeddedModuleID || null;
  let t4;
  if ($[4] !== collaborationSidebarState || $[5] !== onUpdateCollaborationSidebarState || $[6] !== t3) {
    t4 = {
      moduleId: t3,
      collaborationSidebarState,
      onUpdateCollaborationSidebarState
    };
    $[4] = collaborationSidebarState;
    $[5] = onUpdateCollaborationSidebarState;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const {
    setModuleReply,
    removeModuleReply,
    broadcastCommentsMessage,
    moduleParentComment,
    incrementReplyCountBy
  } = useEmbeddedComments(t4);
  let t5;
  if ($[8] !== broadcastCommentsMessage || $[9] !== closeEmbeddedCommentPopover || $[10] !== collaborationSidebarState || $[11] !== embeddedModuleID || $[12] !== isEmbeddedPopoverOpen) {
    t5 = {
      moduleId: embeddedModuleID,
      broadcastCommentsMessage,
      collaborationSidebarState,
      isOpen: isEmbeddedPopoverOpen,
      onClose: closeEmbeddedCommentPopover
    };
    $[8] = broadcastCommentsMessage;
    $[9] = closeEmbeddedCommentPopover;
    $[10] = collaborationSidebarState;
    $[11] = embeddedModuleID;
    $[12] = isEmbeddedPopoverOpen;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const {
    handleReady,
    broadcastDelete
  } = useEmbeddedCommentsMessaging(t5);
  let t6;
  if ($[14] !== closeEmbeddedCommentPopover || $[15] !== iframeContainerID) {
    t6 = {
      iframeContainerID,
      popoverContentWrapperRef,
      closeEmbeddedCommentPopover
    };
    $[14] = closeEmbeddedCommentPopover;
    $[15] = iframeContainerID;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const {
    dimensionsAndCoordinates
  } = useEmbeddedCommentPopover(t6);
  let t7;
  if ($[17] !== broadcastCommentsMessage || $[18] !== broadcastDelete || $[19] !== closeEmbeddedCommentPopover || $[20] !== collaborationSidebarState || $[21] !== embeddedMetaDescription || $[22] !== embeddedModuleID || $[23] !== handleReady || $[24] !== incrementReplyCountBy || $[25] !== isEmbeddedOpenFromCommentMode || $[26] !== moduleParentComment || $[27] !== onUpdateCollaborationSidebarState || $[28] !== removeModuleReply || $[29] !== setModuleReply || $[30] !== userInfo) {
    t7 = embeddedModuleID ? /*#__PURE__*/_jsx("div", {
      id: MINI_COMMENTER_ID,
      children: /*#__PURE__*/_jsx(EmbeddedCommentIframe, {
        contentWrapperRef: popoverContentWrapperRef,
        collaborationSidebarState: collaborationSidebarState,
        onUpdateCollaborationSidebarState: onUpdateCollaborationSidebarState,
        popoverRef: embeddedPopoverRef,
        autoFocus: isEmbeddedOpenFromCommentMode,
        moduleId: embeddedModuleID,
        handleConfirmDeleteCommentModalMessage: broadcastDelete,
        handleReady: handleReady,
        setModuleReply: setModuleReply,
        removeModuleReply: removeModuleReply,
        incrementReplyCountBy: incrementReplyCountBy,
        broadcastCommentsMessage: broadcastCommentsMessage,
        metaDescription: embeddedMetaDescription,
        moduleParentComment: moduleParentComment,
        onClose: closeEmbeddedCommentPopover,
        closePopoverOnOutsideClickRef: closePopoverOnOutsideClickRef,
        userInfo: userInfo
      })
    }) : null;
    $[17] = broadcastCommentsMessage;
    $[18] = broadcastDelete;
    $[19] = closeEmbeddedCommentPopover;
    $[20] = collaborationSidebarState;
    $[21] = embeddedMetaDescription;
    $[22] = embeddedModuleID;
    $[23] = handleReady;
    $[24] = incrementReplyCountBy;
    $[25] = isEmbeddedOpenFromCommentMode;
    $[26] = moduleParentComment;
    $[27] = onUpdateCollaborationSidebarState;
    $[28] = removeModuleReply;
    $[29] = setModuleReply;
    $[30] = userInfo;
    $[31] = t7;
  } else {
    t7 = $[31];
  }
  let t8;
  if ($[32] !== dimensionsAndCoordinates.height || $[33] !== dimensionsAndCoordinates.left || $[34] !== dimensionsAndCoordinates.top || $[35] !== dimensionsAndCoordinates.width) {
    t8 = /*#__PURE__*/_jsx(PopoverContentOverlay, {
      "data-test-id": "embedded-comment-popover-content-overlay",
      ref: embeddedPopoverContentRef,
      top: dimensionsAndCoordinates.top,
      left: dimensionsAndCoordinates.left,
      width: dimensionsAndCoordinates.width,
      height: dimensionsAndCoordinates.height
    });
    $[32] = dimensionsAndCoordinates.height;
    $[33] = dimensionsAndCoordinates.left;
    $[34] = dimensionsAndCoordinates.top;
    $[35] = dimensionsAndCoordinates.width;
    $[36] = t8;
  } else {
    t8 = $[36];
  }
  let t9;
  if ($[37] !== embeddedModuleID || $[38] !== embeddedPopoverPlacement || $[39] !== handleEmbeddedCommentOpenChange || $[40] !== isEmbeddedPopoverOpen || $[41] !== t7 || $[42] !== t8) {
    t9 = /*#__PURE__*/_jsx(Popover, {
      arrowSize: "none",
      autoPlacement: true,
      inlineSize: "380px",
      overflow: "hidden",
      "data-test-id": "mini-commenter-popover",
      "data-onboarding": "mini-commenter-popover",
      open: isEmbeddedPopoverOpen,
      onOpenChange: handleEmbeddedCommentOpenChange,
      placement: embeddedPopoverPlacement,
      popoverRef: embeddedPopoverRef,
      closeOnOutsideClick: true,
      content: t7,
      children: t8
    }, embeddedModuleID);
    $[37] = embeddedModuleID;
    $[38] = embeddedPopoverPlacement;
    $[39] = handleEmbeddedCommentOpenChange;
    $[40] = isEmbeddedPopoverOpen;
    $[41] = t7;
    $[42] = t8;
    $[43] = t9;
  } else {
    t9 = $[43];
  }
  return t9;
}